import * as React from "react"
export const Svg_049 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M31.86 24.158h-4.368v3.613h4.367c1.004 0 1.821-.803 1.821-1.79v-.032c0-.988-.817-1.79-1.82-1.79Z"
      />
      <path
        fill="url(#c)"
        d="M31.86 31.229h-4.368v3.604l4.382-.024c.995-.006 1.806-.81 1.806-1.79 0-.987-.817-1.79-1.82-1.79Z"
      />
      <path
        fill="url(#d)"
        d="M30 10.371c-10.727 0-19.453 8.581-19.453 19.129 0 10.548 8.726 19.129 19.453 19.129 10.727 0 19.453-8.581 19.453-19.129 0-10.548-8.727-19.129-19.453-19.129ZM18.807 31.228h-3.515v-3.457h3.515v3.457Zm18.389-5.247a5.18 5.18 0 0 1-1.381 3.519 5.18 5.18 0 0 1 1.38 3.519c0 2.874-2.377 5.228-5.3 5.247l-.137.001v2.232h-3.516v-2.213l-4.266.022V20.701h4.266v-2.2h3.516v2.2h.101c2.943 0 5.337 2.354 5.337 5.248v.032Zm3.997 5.247v-3.457h3.515v3.457h-3.515Z"
      />
      <path
        fill="url(#e)"
        d="M51.213 8.64C45.547 3.07 38.013 0 30 0 21.987 0 14.453 3.069 8.787 8.64 3.12 14.212 0 21.62 0 29.5c0 7.88 3.12 15.288 8.787 20.86C14.453 55.93 21.987 59 30 59c8.013 0 15.547-3.069 21.213-8.64C56.88 44.788 60 37.38 60 29.5c0-7.88-3.12-15.288-8.787-20.86ZM30 52.086c-12.665 0-22.969-10.132-22.969-22.586C7.031 17.046 17.335 6.914 30 6.914c12.665 0 22.969 10.132 22.969 22.586 0 12.454-10.304 22.586-22.969 22.586Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={28.923}
        x2={30.148}
        y1={24.7}
        y2={28.096}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={28.923}
        x2={30.142}
        y1={31.769}
        y2={35.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={19.544}
        x2={37.578}
        y1={16.11}
        y2={45.791}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={13.875}
        x2={41.687}
        y1={8.85}
        y2={54.624}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h60v59H0z" />
      </clipPath>
    </defs>
  </svg>
)